import classNames from "classnames";
import { ReactNode } from "react";
import { Modal, ModalProps } from "@mantine/core";

import "./styles.sass";

interface Props extends Partial<ModalProps> {
  children: ReactNode;
  modalVisible?: boolean;
  setModalVisible: (modalVisible: boolean) => void;
  modalMessage?: string;
  className?: string;
}

const ModalWrapper = ({
  children,
  modalVisible,
  setModalVisible,
  modalMessage,
  className,
  ...props
}: Props) => {
  return (
    <Modal
      opened={Boolean(modalVisible)}
      onClose={() => setModalVisible(false)}
      classNames={{
        modal: `modal ${className}`,
        header: classNames("modal__header", {
          [`${className}__header`]: className,
        }),
      }}
      {...props}
    >
      <div
        className={classNames("modal__content", {
          [`${className}__content`]: className,
        })}
        data-testid="modal-content"
      >
        {modalMessage && (
          <div
            className={classNames("modal__msg", {
              [`${className}__msg`]: className,
            })}
            data-testid="modal-message"
          >
            {modalMessage}
          </div>
        )}
        <div
          className={classNames("modal__wrapper", {
            [`${className}__wrapper`]: className,
          })}
          data-testid="modal-children"
        >
          {children}
        </div>
      </div>
    </Modal>
  );
};

export default ModalWrapper;
